<template>
    <div class="echarts-demo">
<!--        <wp_card :title="title" shadow="true">-->
<!--            <div slot="head">-->
<!--                <van-cell-group>-->
<!--                    <van-cell title="收入走势">-->
<!--                        <template slot="right-icon">-->
<!--                            <Wp_date_select @onDateSelect="selectDateChart"></Wp_date_select>-->
<!--                        </template>-->
<!--                    </van-cell>-->
<!--                </van-cell-group>-->
<!--            </div>-->

<!--            <div id="chart" ref="chart" style="width:100%; height: 400px"></div>-->
<!--        </wp_card>-->
        <div id="chart" ref="chart" style="width: 100%; height: 300px"></div>
    </div>
</template>

<script>

    // import Wp_date_select from "@/components/custom/Wp_date_select";

    export default {
        name: "Wp_chart_line",
        // components: {Wp_date_select},
        props: {
            pid: {type: String, default: null},
            title: {type: String, default: ''},
            start_time: {type: String, default: ''},
            end_time: {type: String, default: ''},
            incomeData: {type: Array},
        },
        data() {
            return {
                chart: null,
                startTime: this.$store.state.startTime,
                endTime: this.$store.state.endTime,
                option: null,
                income_data:[],
            };
        },
        mounted() {
            this.$log("mounted");
            // [3] 基于准备好的 DOM，初始化 Echarts 实例
            // 使用 ref 访问 DOM, 也可以使用 document.getElementById('chart')
            this.chart = this.$echarts.init(this.$refs.chart, 'light');

            this.initChart();

            // [4] 设置 Echarts 图表数据
            // this.income_data = this.incomeData;

        },
        created() {
            this.income_data = this.incomeData;
        },
        watch:{
            // start_time(){
            //     this.initChart();
            // },
            incomeData(newData){
                if(newData && newData.length > 0){
                    this.income_data = newData;
                    this.initChart();
                }

            }
        },
        methods: {
            // selectDateChart() {
            //     this.initChart();
            // },

            initChart(){
                this.chart.clear();
                this.initData((this.income_data));
            },

            initData(dataList) {
                let titleData = ["预估收入"];
                let x_data = [];
                let _data_1 = [];
                for (let i = dataList.length -1 ; i >= 0; i--) {
                    let _data = dataList[i];

                    let x_title = _data.date;
                    x_title = x_title.replace("-", "\n");

                    let estimateFees = _data.date_income;
                    x_data.push(x_title);
                    _data_1.push(estimateFees);
                }
                let x_data_1 = {
                    name: '预估收入',
                    type: _data_1.length < 2 ? 'bar' : 'line',
                    barWidth: 20,
                    stack: '总量',
                    data: _data_1,
                    markPoint: {
                        data: [
                            {type: 'max', name: '最大值'},
                            {type: 'min', name: '最小值'}
                        ]
                    },
                    // markLine: {
                    //     data: [
                    //         {type: 'average', name: '平均值'}
                    //     ]
                    // }
                    // areaStyle: {
                    //     normal: {
                    //         color: '#091e3b' //改变区域颜色
                    //     }
                    // },
                    itemStyle: {
                        normal: {
                            color: '#ee0a24', //改变折线点的颜色
                            lineStyle: {
                                color: '#ee0a24' //改变折线颜色
                            }
                        }
                    },
                };

                this.option = {
                    title: {
                        text: '',
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: titleData,
                        // x: 'left'
                    },
                    grid: {
                        left: '5px',
                        right: '20px',
                        bottom: '10px',
                        containLabel: true
                    },
                    // toolbox: {
                    //     feature: {
                    //         saveAsImage: {}
                    //     }
                    // },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: x_data,
                        // axisLabel:{
                        //     formet(value){
                        //         // let temp = value.split("").join("\n");
                        //         // this.$log(temp)
                        //         return value.split("").join("\n");
                        //         // return value.replace("-", "\n");
                        //     }
                        // }

                    },
                    yAxis: {
                        type: 'value',
                        name: '单位(元)'
                    },
                    series: [
                        x_data_1
                    ]
                };

                this.chart.setOption(this.option);
            },

            // initData(dataList) {
            //     // this.title='收入走势('+this.startTime+'至'+this.endTime+')';
            //     let titleData = ["预估收入", "商品总金额"];
            //     let x_data = [];
            //     let _data_1 = [];
            //     let _data_2 = [];
            //     for (let i = 0; i < dataList.length; i++) {
            //         let _data = dataList[i];
            //         let x_title = _data.order_Time;
            //         // if(x_title && x_title.indexOf("-") < 0){
            //         //     x_title = x_title + "点";
            //         // }
            //         let estimateFees = _data.estimateFees;
            //         let estimateCosPrices = _data.estimateCosPrices;
            //         x_data.push(x_title);
            //         _data_1.push(estimateFees.toFixed(2));
            //         _data_2.push(estimateCosPrices.toFixed(2));
            //     }
            //     let x_data_1 = {
            //         name: '预估收入',
            //         type: 'line',
            //         stack: '总量',
            //         data: _data_1,
            //         markPoint: {
            //             data: [
            //                 {type: 'max', name: '最大值'},
            //                 {type: 'min', name: '最小值'}
            //             ]
            //         },
            //         markLine: {
            //             data: [
            //                 {type: 'average', name: '平均值'}
            //             ]
            //         }
            //     };
            //     let x_data_2 = {
            //         name: '商品总金额',
            //         type: 'line',
            //         stack: '总量',
            //         data: _data_2,
            //         markPoint: {
            //             data: [
            //                 {type: 'max', name: '最大值'},
            //                 {type: 'min', name: '最小值'}
            //             ]
            //         },
            //         markLine: {
            //             data: [
            //                 {type: 'average', name: '平均值'}
            //             ]
            //         }
            //     };
            //
            //     this.option = {
            //         title: {
            //             text: '',
            //         },
            //         tooltip: {
            //             trigger: 'axis'
            //         },
            //         legend: {
            //             data: titleData,
            //         },
            //         grid: {
            //             left: '2%',
            //             right: '10%',
            //             bottom: '3%',
            //             containLabel: true
            //         },
            //         toolbox: {
            //             feature: {
            //                 saveAsImage: {}
            //             }
            //         },
            //         xAxis: {
            //             type: 'category',
            //             boundaryGap: false,
            //             data: x_data
            //         },
            //         yAxis: {
            //             type: 'value'
            //         },
            //         series: [
            //             x_data_1,
            //             // x_data_2,
            //         ]
            //     };
            //     this.chart.setOption(this.option);
            // },

            // initChart() {
            //     let _data = {
            //         pid: this.pid,
            //         stime: this.startTime,
            //         etime: this.endTime,
            //     };
            //     let that = this;
            //     this.$log(_data);
            //     this.$getOrderChart(_data, function (response) {
            //         this.$log(response);
            //         let data = response.data;
            //         that.initData(data);
            //
            //         // that.$emit('setOrderCount',  response.totals[0].allorders)
            //
            //     })
            // },

            // selectDateChart() {
            //     // this.startTime = selectDate.startTime;
            //     // this.endTime = selectDate.endTime;
            //     this.startTime = this.start_time;
            //     this.endTime = this.end_time;
            //     this.initChart();
            // }
        }
    }
</script>

<style scoped>

</style>